// @flow
export const NavbarLocale = {
  menu_item: {
    about: ["About Us", "Hakkımızda"],
    contact: ["Contact", "İletişim"],
    partners: ["PARTNERS", "ÇÖZÜM ORTAKLARIMIZ"],
    hrsolutions: ["HR SOLUTIONS", "İK ÇÖZÜMLERİMİZ"],
    processing: ["INVENTORY CONSULTING", "ENVANTER SAYIMLARI"],
    register: ["JOIN ENVANTERIUM", "ENVANTERIUM'A DAHİL OL"],
    login: ["LOGIN", "GİRİŞ YAP"]
  },
  language: ["En", "Tr"],
  language_dropdown: {
    english: ["English", "İngilizce"],
    turkish: ["Turkish", "Türkçe"]
  },
  actions: {
    initial_request: ["Join Envanterium", "Envanterium'a Dahil Ol"],
    login: ["Login", "Giriş Yap"]
  }
};



// WEBPACK FOOTER //
// ./src/Locales/Navbar/Navbar.locale.js